import * as React from 'react';
var SvgChevronRightLarge = () => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.085 18.76a.75.75 0 0 1 .04-1.06l6.138-5.7-6.139-5.7a.75.75 0 1 1 1.02-1.1l6.732 6.25a.75.75 0 0 1 0 1.1L9.145 18.8a.75.75 0 0 1-1.06-.04Z",
  fill: "currentColor"
}));
export default SvgChevronRightLarge;